import {ReactElement} from 'react'
import {names} from 'shared/lib'
import styles from './styles.module.scss'

type AdvantageItemProps = {
  title: string
  description?: string
  icon: ReactElement,
  isNew?: boolean
}

export const AdvantageItem: React.FC<AdvantageItemProps> = ({title, description, icon, isNew}) => {
  return (
    <div className={names(styles.item, !description && styles.center)}>
      <div className={styles.item__icon}>{icon}</div>
      <div className={styles.textWrapper}>
        <p className={styles.item__title}>
          {title}
          {isNew ? <span className={styles.item__new}>New</span> : null}
        </p>
        {description ?
          <span className={styles.item__description}>{description}</span>
          : null}
      </div>
    </div>
  )
}